var _g, _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyListGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 146,
    viewBox: "0 0 208 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7187 16.0784L161.094 32.3125C167.12 33.2346 172.004 37.4456 172.004 41.7114V70.2066C172.004 74.4724 167.12 78.6772 161.094 79.5917L47.5268 91.6471C41.5012 92.4167 35 87.359 35 79.3602V28.353C35 20.3541 40.693 15.302 46.7187 16.0784Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.3428 39.3413L156.759 44.307C158.229 44.4143 159.42 45.4184 159.42 46.5495C159.42 47.6805 158.229 48.5412 156.759 48.472L85.3428 45.2672C83.8736 45.2046 82.6826 43.8134 82.6826 42.1598C82.6826 40.5063 83.8736 39.2443 85.3428 39.3413Z",
    fill: "#323F4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.3428 50.1431L136.539 51.3844C138.008 51.4213 139.199 52.4842 139.199 53.7584C139.199 55.0325 138.008 56.0655 136.539 56.0656L85.3428 56.0691C83.8736 56.0691 82.6826 54.7287 82.6826 53.0751C82.6826 51.4215 83.8736 50.1088 85.3428 50.1431Z",
    fill: "#323F4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.3428 66.3459L101.967 65.661C103.436 65.5997 104.627 66.7738 104.627 68.2837C104.627 69.7935 103.436 71.0959 101.967 71.1925L85.3428 72.2718C83.8736 72.366 82.6826 71.1016 82.6826 69.4481C82.6826 67.7945 83.8736 66.4057 85.3428 66.3459Z",
    fill: "#7B8794"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.3213 63.147C69.1631 62.9818 75.5201 56.3187 75.5201 48.2663C75.5201 40.2139 69.1631 33.239 61.3213 32.6934C53.4796 32.1544 47.1226 38.8228 47.1226 47.5817C47.1226 56.3405 53.4796 63.3102 61.3213 63.147Z",
    fill: "#5FE3C0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0441 53.5534C59.3142 53.8479 59.6674 53.9958 60.0212 53.998C60.375 54.0002 60.7281 53.8571 60.9983 53.5679L67.9085 46.3301C68.4482 45.7778 68.4482 44.8565 67.9085 44.2687C67.3688 43.6791 66.494 43.6462 65.9543 44.1985L60.0212 50.394L56.8521 46.8875C56.3124 46.2839 55.4376 46.2591 54.8979 46.8355C54.3582 47.4137 54.3582 48.3742 54.8979 48.9778L59.0441 53.5534Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 207.004,
    height: 145.724,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 19
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.226735 0 0 0 0 0.437054 0 0 0 0 0.687819 0 0 0 0.189057 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyListGreen);
export default __webpack_public_path__ + "static/media/emptyListGreen.5b64637398a54161ac028c6347fe5024.svg";
export { ForwardRef as ReactComponent };